import * as React from 'react';
import { SVGProps } from 'react';
const LoginArrow1Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="279"
    height="281"
    viewBox="0 0 279 281"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.5">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2804 101.044C2.65 108.714 -4.61377 128.413 3.05633 145.044C7.06257 153.73 14.3506 159.861 22.7689 162.643L220.3 276.07C236.155 285.175 256.401 279.706 265.543 263.872C274.7 248.011 269.279 227.709 253.419 218.552L106.619 133.797L259.514 63.2805C276.144 55.6104 283.408 35.9109 275.738 19.2805C268.068 2.65002 248.368 -4.61378 231.738 3.05633L19.2804 101.044Z"
        fill="url(#paint0_linear_4675_83222)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4675_83222"
        x1="2.43128e-06"
        y1="280.474"
        x2="490.262"
        y2="-181.509"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4CEF9" />
        <stop offset="0.817708" stopColor="#7D81C3" />
      </linearGradient>
    </defs>
  </svg>
);
export default LoginArrow1Svg;
